import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

export const GetAllSetupsJobTargetTypes = async ({
    limit,
    page,
    search,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than,
    expense_category_uuid
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);
    if (expense_category_uuid) queryList.push(`expense_category_uuid=${expense_category_uuid}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/job-target?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetSetupsJobTargetTypeById = async ({uuid}) => {
    const queryList = [];
    if (uuid) queryList.push(`uuid=${uuid}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/job-target/view?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
